import React, { useContext, useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Card, Col, Row } from "react-bootstrap"
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import { getGridLocalization, isNullUndefinedOrEmpty, showMessage } from "../../common/Helpers";
import MessageBox from "../../components/Common/Message/MessageBox";
import { __MessageTypes } from "../../common/Dictionaries";
import MainAppContext from "../../MainAppContext";
import MatrixToolbar from "../../components/Products/sPrivilege/Matrix/MatrixToolbar";
import * as XLSX from 'xlsx';
import { cellRenderClassStyle, handlerFilter, setterActionFired, useFilterActionComponentData } from "../../common/Helpers/JqxGridFilter";
import { useGetAllVisorintegrationreportdata as useGetAllItems } from "../../hooks/services/sIntegration/useOfIntegration";
import { ActionButton, SpinnerSize } from "@fluentui/react";
import { proccessIntegrationReportResult } from "../../services/sKPI/integration.service";
import $ from 'jquery';
import Loading from "../../components/Templates/Site/Loading";
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';
import VisorSevenDayReport from "./Chart/VisorSevenDayReport";
export default function IntegrationVisor() {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const profileHasAccess = !contextSite.onlyObserver || (contextSite.securityProps.isSAdmin ||  contextSite.securityProps.isAdmin)
    const _priv_canViewSevenDayReport = (contextSite.securityProps.isSAdmin || contextSite.securityProps.isAdmin);

    const gridRef = useRef();
    const gridRefLog = useRef();
    const [showRequiredGlobalMessage, setShowRequiredGlobalMessage] = useState(false);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [messageConfigLog, setMessageConfigLog] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });


    const [loading, setLoading] = useState(false);    

    const [listItems, setListItems] = useState(null);    
    const [listItemLog, setListItemLog] = useState(null);    
    useGetAllItems(listItems, setListItems, listItemLog, setListItemLog);
    
    useFilterActionComponentData(gridRef, messageConfig, "IntegrationVisor");
    useFilterActionComponentData(gridRefLog, messageConfig, "IntegrationVisorLog");
   
    const getValue = (column, row) => {
        const itemValue = column.editorOptions.find(x => (x.id === row[column.dataField])||(x.key === row[column.dataField]))

        return !isNullUndefinedOrEmpty(itemValue) ? itemValue.name : "";
    }

    const handlerExportData = (exportData) => {
        const workbook = XLSX.utils.book_new();
        const columns = getColumns()
        const aux_rows = []

        if (exportData) {
            const aux_list = listItems.filter(x => x.id > 0);

            aux_list.forEach(row => {
                let aux_row = {};
                columns.forEach(column => {
                    if (column.exportable) {
                        if (column.columntype === 'dropdownlist') {
                            aux_row[column.dataField] = row[column.dataField] !== null ? getValue(column, row) : "";
                        }
                        else {
                            aux_row[column.dataField] = row[column.dataField];
                        }
                    }
                });
    
                aux_rows.push(aux_row);
            });
        }

        const worksheet = XLSX.utils.json_to_sheet(aux_rows, { header: columns.filter(x => (exportData ? x.exportable : x.uploadMasive)).map(column => column.dataField) });
        
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
        XLSX.writeFile(workbook, 'IntegrationVisor_ExportedData.xlsx');
    };
    
    const handlerExportDataLog = (exportData) => {
        const workbook = XLSX.utils.book_new();
        const columns = getLogColumns()
        const aux_rows = []

        if (exportData) {
            const aux_list = listItemLog.filter(x => x.id > 0);

            aux_list.forEach(row => {
                let aux_row = {};
                columns.forEach(column => {
                    if (column.exportable) {
                        if (column.columntype === 'dropdownlist') {
                            aux_row[column.dataField] = row[column.dataField] !== null ? getValue(column, row) : "";
                        }
                        else {
                            aux_row[column.dataField] = row[column.dataField];
                        }
                    }
                });
    
                aux_rows.push(aux_row);
            });
        }

        const worksheet = XLSX.utils.json_to_sheet(aux_rows, { header: columns.filter(x => (exportData ? x.exportable : x.uploadMasive)).map(column => column.dataField) });
        
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
        XLSX.writeFile(workbook, 'IntegrationVisor_ExportedData.xlsx');
    };
    
    const handlerExecuteIntegrations = async () => {
        setLoading(true)
        const items = gridRef.current.props.source.records.filter(x => x.selection === true).map(x => x.id);
            
        await proccessIntegrationReportResult(false, items).then((serviceResponse) => {
            if (serviceResponse.data.succeeded) {
                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }
            setterActionFired("IntegrationVisor", 1)
            setLoading(false)
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            setterActionFired("IntegrationVisor", 1)
            setLoading(false)
        });
    };

    const onVisorCellValuechanged = (e) => {
        listItems[e.args.rowindex][e.args.datafield] = e.args.value

        const copia_listItems = JSON.parse(JSON.stringify(listItems));
        setListItems(copia_listItems)
    };

    const cellsRenderer = (rowIndex, cellValue, editor, cellText, width, height, auxListData, cellType, subType) => {
        switch (cellType) {
            case 'checkbox':
                editor.jqxCheckBox({ checked: (cellValue === 1 || cellValue === '1' || cellValue === 'True' || cellValue === 'true'), width: width });
                break;
            default:
                break;
        }
    };
    
    const getColumns = () => {
        const basicColumns =[
            { index: null, text: 'Id', datafield: 'id', width: '0px', exportable: false, columntype: 'textbox', editable: false, hidden: true},
            { index: null, text: t('data-lang-lbl-select'),                      dataField: 'selection',                 width: '6%',  exportable: false, pinned: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'checkbox', 'string'), columntype: 'checkbox', filterable: false, editable: true, hidden: true},
            
            { index: 0,    text: t('data-lang-lbl-code'),                        dataField: 'integrationReportDataCode', width: '10%', exportable: true,    columntype: 'textbox',     editable: false },
            { index: 1,    text: t('data-lang-lbl-field-uri'),                   dataField: 'uri',                       width: '28%', exportable: true,    columntype: 'textbox',     editable: false },
            { index: 2,    text: t('data-lang-lbl-field-integrationReportName'), dataField: 'integrationReportName',     width: '12%', exportable: true,    columntype: 'numberinput', editable: false, cellsalign: 'right' },
            { index: 3,    text: t('data-lang-lbl-field-executionDate'),         dataField: 'executionDate',             width: '10%', exportable: true,    columntype: 'datetimeinput',  cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'datetimeinput', listItems), editable: false, cellsformat: 'dd-MM-yyyy - HH:mm:ss', cellsalign: 'right' },
            { index: 4,    text: t('data-lang-lbl-field-jsonResponse'),          dataField: 'jsonResponse',              width: '20%', exportable: true,    columntype: 'textbox',
                cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties) => {
                    const encodedJson = encodeURIComponent(JSON.stringify(value));
                    return `<div class="copy-text h-100">
                                <div class="text w-100 pt-2 m-0 text-end">${value}</div>
                                <button class="copy-button text-end" title="${t('data-lang-lbl-copy')}" data-text="${encodedJson}">
                                    <i data-icon-name="${t('data-lang-lbl-copy')}" aria-hidden="true" class="ms-Icon ms-Button-icon copy-icon"></i>
                                </button>
                            </div>`
                }, editable: false
            },
            { index: 5,    text: t('data-lang-lbl-field-executed'),              dataField: 'executed',                  width: '5%',  exportable: true,    columntype: 'textbox',
                cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties) => {
                    const displayText = value ? t('data-lang-lbl-yes') : t('data-lang-lbl-no');
                    return `<div class="text-center" style="margin-top: 8.5px;">${displayText}</div>`;
                }, editable: false
            },
            { index: 6,    text: t('data-lang-lbl-field-hasError'),              dataField: 'hasError',                  width: '5%',  exportable: true,    columntype: 'textbox',
                cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties) => {
                    const displayText = value ? t('data-lang-lbl-yes') : t('data-lang-lbl-no');
                    return `<div class="text-center" style="margin-top: 8.5px;">${displayText}</div>`;
                }, editable: false
            },
            { index: 7,    text: t('data-lang-lbl-field-executedDate'),          dataField: 'executedDate',              width: '10%', exportable: true,    columntype: 'datetimeinput',  cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'datetimeinput', listItems), editable: false, cellsformat: 'dd-MM-yyyy - HH:mm:ss', cellsalign: 'right' },        
        ]

        return basicColumns;
    };

    const getLogColumns = () => {   
        const basicColumns =[
            { index: null, text: 'Id', dataField: 'id', width: '0px', exportable: false,  columntype: 'textbox', editable: false, hidden: true},
            { index: 0,    text: t('data-lang-lbl-field-elementId'),             dataField: 'elementId',             width: '10%', exportable: true,  columntype: 'textbox',     editable: false, pinned: true },
            { index: 1,    text: t('data-lang-lbl-field-elementRefNemo'),        dataField: 'elementRefNemo',        width: '10%', exportable: true,  columntype: 'numberinput', editable: false, pinned: true },
            { index: 2,    text: t('data-lang-lbl-field-internalCode'),          dataField: 'internalCode',          width: '10%', exportable: true,  columntype: 'numberinput', editable: false, pinned: true, cellsalign: 'right' },
            { index: 3,    text: t('data-lang-lbl-field-externalCode'),          dataField: 'externalCode',          width: '10%', exportable: true,  columntype: 'textbox',     editable: false, pinned: true, cellsalign: 'right' },
            { index: 4,    text: t('data-lang-lbl-field-configurationCode'),     dataField: 'integrationConfigCode', width: '10%', exportable: true,  columntype: 'textbox',     editable: false, cellsalign: 'right' },
            { index: 5,    text: t('data-lang-lbl-field-executionDate'),         dataField: 'executionDate',         width: '10%', exportable: true,  columntype: 'datetimeinput',  cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'datetimeinput', listItems), editable: false, cellsformat: 'dd-MM-yyyy - HH:mm:ss', cellsalign: 'right' },
            { index: 6,    text: t('data-lang-lbl-field-integratedDate'),        dataField: 'integratedDate',        width: '10%', exportable: true,  columntype: 'datetimeinput',  cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'datetimeinput', listItems), editable: false, cellsformat: 'dd-MM-yyyy - HH:mm:ss', cellsalign: 'right' },
            { index: 7,    text: t('data-lang-lbl-field-reportIntegrationCode'), dataField: 'reportIntegrationCode', width: '12%', exportable: true,  columntype: 'textbox',     editable: false, cellsalign: 'right' },
            { index: 8,    text: t('data-lang-lbl-field-integrated'),            dataField: 'integrated',            width: '5%',  exportable: true,  columntype: 'textbox',
                cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties) => {
                    //const displayText = listItemLog[row].integrated ? t('data-lang-lbl-yes') : t('data-lang-lbl-no');
                    const displayText = value ? t('data-lang-lbl-yes') : t('data-lang-lbl-no');
                    return `<div class="text-center" style="margin-top: 8.5px;">${displayText}</div>`;
                }, editable: false
            },
            { index: 9,    text: t('data-lang-lbl-field-connector'),        dataField: 'connector',              width: '15%', exportable: true,  columntype: 'numberinput', editable: false, cellsalign: 'right' },
            { index: 10,   text: t('data-lang-lbl-field-jsonRequest'),      dataField: 'jsonRequest',            width: '13%', exportable: true,  columntype: 'numberinput', editable: false, cellsalign: 'right' },
            { index: 11,   text: t('data-lang-lbl-field-jsonResponse'),     dataField: 'jsonResponse',           width: '25%', exportable: true,  columntype: 'numberinput',
                cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties) => {
                    const encodedJson = encodeURIComponent(JSON.stringify(value));
                    return `<div class="copy-text h-100">
                                <div class="text w-100 pt-2 m-0 text-end">${value}</div>
                                <button class="copy-button-log text-end" title="${t('data-lang-lbl-copy')}" data-text="${encodedJson}">
                                    <i data-icon-name="${t('data-lang-lbl-copy')}" aria-hidden="true" class="ms-Icon ms-Button-icon copy-icon"></i>
                                </button>
                            </div>`
                },
                editable: false, cellsalign: 'right'
            },
        ]

        return basicColumns;
    };

    const handleCopyClick = (e) => {
        const textToCopy = decodeURIComponent(e.target.parentNode.getAttribute('data-text'));
        
        if (textToCopy) {
            navigator.clipboard.writeText(textToCopy);
        }
    };

    useEffect(() => {
        const buttons = document.querySelectorAll('.copy-button');
        buttons.forEach(button => button.addEventListener('click', handleCopyClick));
    
        return () => {
            buttons.forEach(button => button.removeEventListener('click', handleCopyClick));
        };
    }, [listItems]);

    useEffect(() => {
        const $grid = $(gridRefLog.current);
    
        // Verificar que los botones existan en el DOM
        const attachCopyEventListeners = () => {
          const buttons = $grid.find('.copy-button-log');
          if (buttons.length > 0) {
            buttons.off('click', handleCopyClick); // Eliminar cualquier event listener existente
            buttons.on('click', handleCopyClick);  // Agregar el nuevo event listener
          }
        };
    
        // Usar delegación de eventos para adjuntar el evento de clic a los botones .copy-button
        $grid.on('click', '.copy-button-log', handleCopyClick);
    
        // Verificar los botones después de que se haya renderizado el componente
        setTimeout(() => {
          attachCopyEventListeners();
        }, 500);
    
        return () => {
          // Limpiar los event listeners al desmontar el componente
          $grid.off('click', '.copy-button-log', handleCopyClick);
        };
    }, [listItemLog]);

    return (
        <div className="col-12 listWithActions h-100">
            <Row>
                <Card className="h-100">
                    <Card.Header>
                        <Card.Title className="d-flex justify-content-between">
                            <h4><b>{t('data-lang-maintainer-title-IntegrationVisor')}</b></h4>
                        </Card.Title>
                    </Card.Header>
                    {
                        _priv_canViewSevenDayReport &&
                        <Card.Body className="access-per-month-form-body h-100 overflow-hidden-deprecated">
                            <VisorSevenDayReport />
                        </Card.Body>
                    }
                    <Card.Footer>
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Card.Footer>
                    <Card.Body className="access-per-month-form-body h-100 overflow-hidden-deprecated">
                        <div className="align-items-center h-100">
                            <div className="d-none">                                                        
                                <a id="btnGetTemplateJson" href={undefined} download="Template.csv" style={{display: "none"}} rel="noreferrer noopener" target='_blank'>#</a>
                            </div>
                            {
                                listItems &&
                                <>
                                    <Row>
                                        {
                                            loading &&
                                            <Col></Col>
                                        }
                                        <Col className={"text-end " + (loading ? "col-auto" : "")}>
                                        {
                                            !loading && false &&
                                            <ActionButton iconProps={{iconName: "ServerProcesses"}} text={t('data-lang-btn-executeselectedintegrations')} onClick={handlerExecuteIntegrations} />
                                        }
                                        {
                                            loading &&
                                            <Loading
                                                inputParam_ShowLoading={true}
                                                inputParam_ShowText={true}
                                                inputParam_Text={t('data-lang-lbl-executing')}
                                                inputParam_Width={'35px'}
                                                inputParam_Height={'35px'}
                                                inputParam_Left={""}
                                                inputParam_Style={{marginTop: 0}}
                                                inputParam_ColClassName={"me-2"}
                                                inputParam_MarginLeft={"auto"}
                                                inputParam_SpinnerSize={SpinnerSize.medium}
                                                inputParam_Vertical={false}
                                            />
                                        }
                                        </Col>
                                        <Col className="col-auto">
                                            <MatrixToolbar       
                                                inputParam_HandleExportData={handlerExportData}
                                                inputParam_HandleSaveData={undefined}                                    
                                                inputParam_HandleUploadData={undefined}
                                                inputParam_HandleAddRow={undefined}                                   
                                                inputParam_Configuration={{
                                                    buttons: {
                                                        showRowButtons: false,
                                                        showExportData: profileHasAccess,
                                                        showAddMasiveData: false,
                                                        showAddData: false,
                                                        showDownloadTemplate: false,
                                                        showSaveAllData: false,
                                                        groupedButtons: false
                                                    },
                                                    auxiliarListCallbackOnAdd: null,
                                                }}
                                                showRequiredMessage={showRequiredGlobalMessage}
                                            />
                                        </Col>
                                    </Row>
                                    
                                    <JqxGrid
                                        ref={gridRef}
                                        altrows={true}
                                        enabletooltips={true}
                                        width={'100%'}
                                        theme={'light'} 
                                        height={"350px"}
                                        editable={true}
                                        sortable={true}
                                        filterable={true}
                                        showfilterrow={true} 
                                        localization={getGridLocalization(t)}
                                        source={ new jqx.dataAdapter({
                                            localData: listItems,
                                            dataType: 'array',
                                            dataFields: [            
                                                { name: 'id', type: 'int' },
                                                { name: 'selection', type: 'bool' },
                                                { name: 'integrationReportDataCode', type: 'string' },
                                                { name: 'uri', type: 'string' },
                                                { name: 'integrationReportName', type: 'string' },
                                                { name: 'executionDate', type: 'date' },
                                                { name: 'jsonResponse', type: 'string' },
                                                { name: 'executed', type: 'bool' },
                                                { name: 'hasError', type: 'bool' },
                                                { name: 'executedDate', type: 'date' }
                                            ],
                                            id: 'id'
                                        })}
                                        columns={getColumns()}                                    
                                        onCellvaluechanged={onVisorCellValuechanged}
                                        onFilter={(event) => handlerFilter(event, 'IntegrationVisor')}
                                    />
                                </>
                            }
                        </div>
                    </Card.Body>
                </Card> 
            </Row> 
            <Row><br></br></Row>
            <Row>
                <Card className="h-100">
                    <Card.Header>
                        <Card.Title className="d-flex justify-content-between">
                            <h4><b>{t('data-lang-maintainer-title-IntegrationVisorLog')}</b></h4>
                        </Card.Title>
                    </Card.Header>
                    <Card.Footer>
                        <MessageBox
                            inputParam_Message={ messageConfigLog.message }
                            inputParam_Display={ messageConfigLog.showMessage }
                            inputParam_MessageType={ messageConfigLog.messageType }
                            inputParam_SetterMessage={ setMessageConfigLog }
                        />
                    </Card.Footer>
                    <Card.Body className="access-per-month-form-body h-100 overflow-hidden-deprecated">
                        <div className="align-items-center h-100">
                            <div className="d-none">                                                        
                                <a id="btnGetTemplateJson" href={undefined} download="Template.csv" style={{display: "none"}} rel="noreferrer noopener" target='_blank'>#</a>
                            </div>
                            {
                                listItemLog &&
                                <>
                                    <MatrixToolbar       
                                        inputParam_HandleSaveData={undefined}                                    
                                        inputParam_HandleUploadData={undefined}
                                        inputParam_HandleExportData={handlerExportDataLog}
                                        inputParam_HandleAddRow={undefined}                                   
                                        inputParam_Configuration={{
                                            buttons: {
                                                showRowButtons: false,
                                                showExportData: profileHasAccess,
                                                showAddMasiveData: false,
                                                showAddData: false,
                                                showDownloadTemplate: false,
                                                showSaveAllData: false,
                                                groupedButtons: false
                                            },
                                            auxiliarListCallbackOnAdd: null,
                                        }}
                                        showRequiredMessage={showRequiredGlobalMessage}
                                    />
                                    <JqxGrid 
                                        ref={gridRefLog}
                                        className="gridlog"
                                        altrows={true}
                                        enabletooltips={true}
                                        width={'100%'}
                                        theme={'light'} 
                                        editable={false}
                                        height={"350px"}
                                        sortable={true}
                                        filterable={true}
                                        showfilterrow={true} 
                                        localization={getGridLocalization(t)}
                                        source={ new jqx.dataAdapter({
                                            localData: listItemLog,
                                            dataType: 'array',
                                            dataFields: [            
                                                { name: 'id', type: 'int' },
                                                { name: 'elementId', type: 'number' },
                                                { name: 'elementRefNemo', type: 'string' },
                                                { name: 'internalCode', type: 'string' },
                                                { name: 'externalCode', type: 'string' },
                                                { name: 'integrationConfigCode', type: 'string' },
                                                { name: 'executionDate', type: 'date' },
                                                { name: 'integratedDate', type: 'date' }, 
                                                { name: 'reportIntegrationCode', type: 'string' },
                                                { name: 'connector', type: 'string' },
                                                { name: 'jsonRequest', type: 'string' },
                                                { name: 'jsonResponse', type: 'string' },
                                                { name: 'integrated', type: 'bool' },
                                            ],
                                            id: 'id'
                                        })}
                                        columns={getLogColumns()}                                    
                                        onFilter={(event) => handlerFilter(event, 'IntegrationVisorLog')}
                                    />
                                </>
                            }
                        </div>
                    </Card.Body>
                </Card> 
            </Row>                     
        </div>
    ); 
}

